import { useCallback, useState } from 'react';
import type { ArtifactId, OverlayKind } from '@/artifacts/navigation-map';
import { useGeoMarkupStore } from '@/store';
import type { Note } from '@/types/notes';

interface ArtifactNavigation {
  openArtifact: (
    artifactId: ArtifactId,
    kind: OverlayKind,
    itemId?: string
  ) => void;
  closeOverlay: () => void;
}

export function useNoteDetailPanelActions(
  selectedNote: Note | null,
  { openArtifact, closeOverlay }: ArtifactNavigation
) {
  const deleteNote = useGeoMarkupStore((state) => state.notes.deleteNote);

  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);

  const handleEdit = useCallback(() => {
    if (selectedNote) {
      openArtifact('notes', 'edit', selectedNote.shortId);
    }
  }, [selectedNote, openArtifact]);

  const handleDeleteClick = useCallback(() => {
    setDeleteConfirmOpen(true);
  }, []);

  const handleDeleteCancel = useCallback(() => {
    setDeleteConfirmOpen(false);
  }, []);

  const handleDeleteConfirm = useCallback(async () => {
    if (!selectedNote) return;

    const success = await deleteNote(selectedNote.id);
    if (success) {
      setDeleteConfirmOpen(false);
      closeOverlay();
    }
  }, [selectedNote, deleteNote, closeOverlay]);

  return {
    deleteConfirmOpen,
    handleEdit,
    handleDeleteClick,
    handleDeleteCancel,
    handleDeleteConfirm,
  };
}
